module.exports = __webpack_public_path__ + "static/media/md.90ce5a48.png";